import { agentFilterOptions, conversionAmount } from '../../constants/app.constants';
import { conversionRateActionTypes as ACTION } from '../actionTypes';


const initialState = {
  loading: false,
  data:{conversionAmount},
  
  error: '',
};

const conversionRateReducer = (state = initialState, action) => {    
  switch (action.type) {
    case ACTION.SET_CONVERSION_RATE:
      return {
        ...state,
        data: { ...state.data, conversionAmount: action.payload },
      };
    default:
      return state;
  }
};

export default conversionRateReducer;